import { campaigns } from './campaigns';

const spend = campaigns.reduce((a, c) => a + c.spend_usd, 0);
const conversions = campaigns.reduce((a, c) => a + c.conversions, 0);
const revenue = campaigns.reduce((a, c) => a + c.revenue_usd, 0);
const roas = Number((revenue / spend).toFixed(2));
const cpa = Number((spend / conversions).toFixed(2));

export const dashboard = {
  summary: {
    has_data: true,
    totals: {
      spend_usd: spend,
      conversions,
      revenue_usd: revenue,
      roas,
      cpa,
      ctr: 0.021,
    },
    // Flat fallbacks — kept for existing invariant tests (demoStore, routes.core)
    // and for any axios consumers that read top-level fields.
    spend_usd: spend,
    conversions,
    revenue_usd: revenue,
    roas,
    ctr: 0.021,
    cpa,
    daily: Array.from({ length: 7 }).map((_, i) => ({
      date: `2026-06-${String(11 + i).padStart(2, '0')}`,
      spend_usd: Math.round((spend / 7) * (0.85 + i * 0.05)),
      conversions: Math.round((conversions / 7) * (0.85 + i * 0.05)),
      revenue_usd: Math.round((revenue / 7) * (0.85 + i * 0.05)),
    })),
  },
};
